import {clsx} from 'clsx'
import {twMerge} from 'tailwind-merge'

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

const MIME_EXTENSION_MAP = {
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xlsx',
  'application/vnd.ms-excel': '.xls',
  'text/csv': '.csv',
  'application/pdf': '.pdf',
  'application/json': '.json',
}

const detectExtensionFromMagicBytes = (blob) =>
  new Promise((resolve) => {
    if (!blob) return resolve(null)
    try {
      const reader = new FileReader()
      reader.onload = () => {
        const bytes = new Uint8Array(reader.result)
        if (bytes[0] === 0x50 && bytes[1] === 0x4b) return resolve('.xlsx')
        if (bytes[0] === 0xd0 && bytes[1] === 0xcf && bytes[2] === 0x11 && bytes[3] === 0xe0) return resolve('.xls')
        if (bytes[0] === 0x25 && bytes[1] === 0x50 && bytes[2] === 0x44 && bytes[3] === 0x46) return resolve('.pdf')
        resolve(null)
      }
      reader.onerror = () => resolve(null)
      reader.readAsArrayBuffer(blob.slice(0, 4))
    } catch {
      resolve(null)
    }
  })

export const downloadBlobFile = async (blob, fileName = 'file.pdf') => {
  let expectedExt = await detectExtensionFromMagicBytes(blob)
  if (!expectedExt) {
    const mimeType = blob?.type?.split(';')[0]
    expectedExt = MIME_EXTENSION_MAP[mimeType]
  }
  if (expectedExt) {
    const lastDotIdx = fileName.lastIndexOf('.')
    if (lastDotIdx === -1) {
      fileName = fileName + expectedExt
    } else if (fileName.substring(lastDotIdx) !== expectedExt) {
      fileName = fileName.substring(0, lastDotIdx) + expectedExt
    }
  }
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  link.click()
  URL.revokeObjectURL(url)
}

export const downloadCSVFiles = (csvString, fileName = 'File.csv') => {
  const blob = new Blob(['\uFEFF' + csvString], {type: 'text/csv;charset=utf-8;'})

  const link = document.createElement('a')

  link.download = fileName

  link.href = URL.createObjectURL(blob)

  link.click()

  URL.revokeObjectURL(link.href)
}
export const getDateWithTimeString = () => {
  const date = new Date()
  const isoString = date.toISOString()
  const formattedDate = isoString
    .replace('T', '_')
    .replace(/\.\d{3}Z/, '')
    .replaceAll(':', '')
  return formattedDate
}

export function capitalizeFirst(text) {
  if (!text) return '-'
  const lower = text.toLowerCase()
  return lower.charAt(0).toUpperCase() + lower.slice(1)
}

export function formatAddress(address) {
  if (!address) return '-'

  // Split by comma, trim, remove null/undefined/"null"
  const parts = address
    .split(',')
    .map(part => part && part.trim())
    .filter(part => part && part.toLowerCase() !== 'null')

  if (parts.length === 0) return '-'

  // Capitalize each word in each part
  const capitalize = str => str.replace(/\w\S*/g, w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())

  return parts.map(capitalize).join(', ')
}

export function formatDateToYMD(dateString) {
  if (!dateString) return '-'
  return dateString.split('T')[0]
}
